import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { isTelegramLink } from './channel-list';

/** Props of {@link EmptyChannels}. */
export interface EmptyChannelsProps {
  readonly affiliateChannelUrl: string | null;
  readonly onJoin: (url: string) => void;
  readonly onReload: () => void;
}

/**
 * The no-channel state (S5 R6, R7; FXM-01 §5): why the list is empty, join the affiliate's
 * channel in Telegram (a `t.me` link only), then refresh. E12 shows it too (S9 R13).
 */
export function EmptyChannels({
  affiliateChannelUrl,
  onJoin,
  onReload,
}: EmptyChannelsProps): ReactElement {
  const { t } = useTranslation();
  return (
    <Stack spacing={1.5}>
      <Typography variant="h2">{t('onboarding.channels.empty.title')}</Typography>
      <Typography>{t('onboarding.channels.empty.body')}</Typography>
      {isTelegramLink(affiliateChannelUrl) ? (
        <Button
          variant="contained"
          onClick={() => {
            onJoin(affiliateChannelUrl);
          }}
        >
          {t('onboarding.channels.empty.join')}
        </Button>
      ) : null}
      <Button variant="outlined" onClick={onReload}>
        {t('onboarding.channels.empty.refresh')}
      </Button>
    </Stack>
  );
}
